import { useForm } from "react-hook-form";

import { Grid2, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";

type FormularioFiltro = {
  fecha: Date | null;
};

const validationSchema: yup.ObjectSchema<FormularioFiltro> = yup.object().shape({
  fecha: yup.date().required("Selecciona un mes y año"),
});

interface FiltrosComponentProps {
  handleFilter: (mes: number, anio: number) => void;
}

export const FiltrosComponent = ({ handleFilter }: FiltrosComponentProps) => {

  const getCurrentMonthFirstDay = () => {
    const hoy = new Date();
    return new Date(hoy.getFullYear(), hoy.getMonth(), 1);
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm<FormularioFiltro>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      fecha: getCurrentMonthFirstDay(),
    },
  });

  const fechaActual = watch("fecha");
  
  const onSubmit = (data: FormularioFiltro) => {
    if(!data.fecha) return
    handleFilter(data.fecha.getMonth() + 1, data.fecha.getFullYear());
  };

  return (
    <CustomAccordion title="Filtros" expandedDefault>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid2 container spacing={2} sx={{ 
          marginTop: 1,
          alignItems: "center",
        }}>
          {/* Contenedor del DatePicker */}
          <Grid2 size={{ xs: 4 }} sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1
          }}>
            <InputFecha
              name="fecha"
              control={control}
              label="Seleccionar Mes y Año"
              onlyMonthPicker
              fecha={fechaActual}
            />

            {errors.fecha && (
              <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                {errors.fecha.message}
              </Typography>
            )}
          </Grid2>

          {/* Contenedor del Botón */}
          <Grid2 size={{ xs: 8 }} sx={{ 
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}>
            <MButton
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<FilterListIcon />}
              sx={{ 
                height: "40px", 
                whiteSpace: "nowrap",
                px: 3
              }}
            >
              Filtrar
            </MButton>
          </Grid2>
        </Grid2>
      </form>
    </CustomAccordion>
  );
};